
    var riot = require('riot')
    import { InfiniteScroll } from './gb-infinite-scroll';
riot.tag2('gb-infinite-scroll', '<ul ref="scroller" class="gb-scroller"> <div ref="runway" class="gb-runway"></div> </ul>', 'gb-infinite-scroll .gb-scroller,[data-is="gb-infinite-scroll"] .gb-scroller{ margin: 0; padding: 0; overflow-x: hidden; overflow-y: scroll; -webkit-overflow-scrolling: touch; width: 100%; height: 100%; position: absolute; box-sizing: border-box; contain: layout; will-change: transform; } gb-infinite-scroll .gb-runway,[data-is="gb-infinite-scroll"] .gb-runway{ position: absolute; height: 1px; width: 1px; transition: transform 0.2s; }', '', function(opts) {
    this._mixin(InfiniteScroll);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/infinite-scroll/gb-infinite-scroll.tag.html